import { createAction, props } from '@ngrx/store';
import { SaleFullViewingLogStatistcs, SaleViewingLogSummary, StatsFilters } from 'src/app/models/statistics/statistics.model';
import { LookupModel } from '../../../models/common/lookup.model';

export const GetSaleFullViewingLog = createAction(
  '[Sales] Get Sale Full Viewing Log',
  props<{ saleUID: string, uid?: string, saleMemberId: number, typo?: string, filter?: StatsFilters }>()
);
export const GetSaleFullViewingLogSuccess = createAction(
  '[Sales] Get Full Viewing Log Success',
  props<{ saleFullViewingLogStatistcs: SaleFullViewingLogStatistcs[] }>()
);
export const GetSaleFullViewingLogFailure = createAction(
  '[Sales] Get Full Viewing Log Failure',
  props<{ err: any }>()
);
export const GetSaleViewingSummary = createAction(
  '[Sales] Get Sale Viewing Summary',
  props<{ saleUID: string, uid?: string, saleMemberId: number, typo?: string, filter?: StatsFilters }>()
);
export const GetSaleViewingSummarySuccess = createAction(
  '[Sales] Get Full Viewing Log Success',
  props<{ saleViewingSummary: SaleViewingLogSummary[] }>()
);
export const GetSaleViewingSummaryFailure = createAction(
  '[Sales] Get Full Viewing Log Failure',
  props<{ err: any }>()
);

//Get User
export const getConsignorSales = createAction('[Sales] Get Consignor Sale', props<{ saleUID: string, consignorUID?: string }>());
export const getConsignorSalesSuccess = createAction('[User] Get Consignor Sale Success', props<{ sales: LookupModel[] }>());
export const getConsignorSalesFailure = createAction('[User] Get Consignor Sale Failure', props<{ error: any }>());

export const MarkAsArchive = createAction(
  '[Sales] Mark As Archive',
  props<{ activityLogId: number, active: boolean }>()
);
export const MarkAsArchiveSuccess = createAction(
  '[Sales] Mark As Archive Success',
  props<{ response: boolean }>()
);
export const MarkAsArchiveFailure = createAction(
  '[Sales] Mark As Archive Failure',
  props<{ err: any }>()
);
